import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-area text-center w-full h-full min-h-screen items-center justify-center flex flex-col overflow-auto p-4 pt-12",
  id: "main-area"
}
const _hoisted_2 = { class: "flex flex-1 items-center justify-center" }
const _hoisted_3 = { class: "w-full justify-center mt-auto text-xs lg:text-sm text-muted-green z-10" }

import { useImageViewer } from './features/composables/useImageViewer';
import NavBar from './features/components/NavBar.vue';
import MobileNavBar from './features/components/MobileNavBar.vue';
import FullScreenImage from './features/global/FullScreenImage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentYear = new Date().getFullYear();
const { viewerPhase } = useImageViewer();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MobileNavBar, { class: "block lg:hidden" }),
    _createVNode(NavBar, {
      class: _normalizeClass(["hidden lg:block transition-[opacity,transform] duration-[500ms] ease-[cubic-bezier(0.22,1,0.36,1)]", _unref(viewerPhase) === 'opening' || _unref(viewerPhase) === 'open' ? 'opacity-0 pointer-events-none -translate-y-1' : 'opacity-100 pointer-events-auto translate-y-0'])
    }, null, 8, ["class"]),
    _createVNode(FullScreenImage),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, { class: "z-10 w-full" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("footer", _hoisted_3, [
        _createElementVNode("span", null, "© " + _toDisplayString(_unref(currentYear)) + " Clair Green. All rights reserved.", 1)
      ]),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"shapes\"><div class=\"circles\"><div></div><div></div><div></div><div></div></div><div class=\"triangles\"><div></div><div></div></div><div class=\"pentagons\"><div></div><div></div></div><div class=\"hexagons\"><div></div><div></div></div><div class=\"flowers\"><div></div><div></div></div></div>", 1))
    ])
  ]))
}
}

})